// Copyright (c) Microsoft. All rights reserved.

import { BaseService } from './BaseService';

export interface UserPolicyAgreement {
    id: string;
    userId: string;
    agreedAt: string;
    agreed: boolean;
}

export class UserPolicyAgreementService extends BaseService {
    /**
     * Get the policy agreement status for the current user.
     */
    public async getPolicyAgreementAsync(accessToken: string): Promise<UserPolicyAgreement | null> {
        try {
            const result = await this.getResponseAsync<UserPolicyAgreement>(
                {
                    commandPath: 'policyAgreement',
                    method: 'GET',
                },
                accessToken,
            );
            return result;
        } catch (error: unknown) {
            // 404 is expected when user hasn't agreed yet
            const err = error as { status?: number; message?: string };
            if (err.status === 404 || err.message?.includes('404')) {
                return null;
            }
            throw error;
        }
    }

    /**
     * Create a policy agreement for the current user.
     */
    public async createPolicyAgreementAsync(accessToken: string): Promise<UserPolicyAgreement> {
        const result = await this.getResponseAsync<UserPolicyAgreement>(
            {
                commandPath: 'policyAgreement',
                method: 'POST',
            },
            accessToken,
        );
        return result;
    }
}
